import { Injectable } from '@angular/core';

import { Board } from 'src/models';

import { GenericObjectsService } from './generic-objects.service';

@Injectable({
  providedIn: 'root',
})
export class BoardsService extends GenericObjectsService<Board> {
  protected baseUrl = '/boards';
}
